import {
  GLOBAL_RATE_LIMIT_CAPACITY_DEFAULT as hi,
  GLOBAL_RATE_LIMIT_REFILL_RATE_DEFAULT as ci,
} from "../common/constants.js";
export default class li {
  constructor(
    t = 0,
    i = [],
    s = [],
    h = [],
    e = null,
    l = null,
    r = { enabled: !1 },
    n = { enabled: !1, refresh_rate_limit: void 0 },
    a = { enabled: !0, capacity: hi, refill_rate: ci, endpoint_overrides: {} },
    o = null,
    u = null,
    c = null,
  ) {
    (this.kc = t),
      (this.Ic = i),
      (this.Kc = s),
      (this.Pc = h),
      (this.Oc = e),
      (this.xc = l),
      (this.Gc = r),
      (this.Xr = n),
      (this.Nc = a),
      (this.banners = o),
      (this.dust = u),
      (this.Hc = c),
      (this.kc = t),
      (this.Ic = i),
      (this.Kc = s),
      (this.Pc = h),
      (this.Oc = e),
      (this.xc = l),
      (this.Gc = r),
      (this.Xr = n),
      (this.Nc = a),
      (this.banners = o),
      (this.dust = u),
      (this.Hc = c);
  }
  gt() {
    return {
      s: "6.5.0",
      l: this.kc,
      e: this.Ic,
      a: this.Kc,
      p: this.Pc,
      m: this.Oc,
      v: this.xc,
      c: this.Gc,
      f: this.Xr,
      grl: this.Nc,
      b: this.banners,
      d: this.dust,
      rb: this.Hc,
    };
  }
  static _u(t) {
    let i = t.l;
    return (
      "6.5.0" !== t.s && (i = 0),
      new li(i, t.e, t.a, t.p, t.m, t.v, t.c, t.f, t.grl, t.b, t.d, t.rb)
    );
  }
}
